const LEGAL_HUB = "https://fedefitnesstest.amsolutions.dev/legal";
const CONTACT_MAIL = "supporto@fedefitnessitalia.com";

const FOOTER_LINKS = [
  { label: "Privacy Policy", href: "/privacy-policy", testid: "footer-privacy-link" },
  { label: "Cookie Policy", href: LEGAL_HUB, external: true, testid: "footer-cookie-link" },
  { label: "Termini e condizioni", href: LEGAL_HUB, external: true, testid: "footer-terms-link" },
  {
    label: "Gestione abbonamento",
    href: `mailto:${CONTACT_MAIL}?subject=Gestione%20abbonamento%20Tempio%20Vivo`,
    testid: "footer-subscription-link",
  },
  { label: "Contatti", href: `mailto:${CONTACT_MAIL}`, testid: "footer-contacts-link" },
];

export const Footer = () => (
  <footer className="border-t border-[#1B1B1B] bg-[#080808] py-12">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="flex flex-col items-center gap-8 sm:flex-row sm:justify-between">
        <div className="text-center sm:text-left">
          <p className="font-display text-xl font-semibold uppercase tracking-[0.2em] text-[#C9A45C]">
            Tempio Vivo
          </p>
          <p className="mt-1 text-xs uppercase tracking-widest text-[#8F7138]">
            Fede &amp; Fitness Italia — Fede in Azione
          </p>
          <p className="mt-2 text-[11px] text-[#5a5a5a]">
            Freedom Fitness Consulting LLC — 30 N Gould St, STE R, Sheridan, WY
            82801, USA
          </p>
        </div>
        <nav aria-label="Collegamenti legali">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            {FOOTER_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  data-testid={link.testid}
                  href={link.href}
                  {...(link.external
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                  className="text-xs uppercase tracking-wider text-[#8a8a8a] underline-offset-4 transition-colors hover:text-[#C9A45C] hover:underline"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <p className="mt-10 text-center text-[11px] text-[#4a4a4a]">
        © {new Date().getFullYear()} Tempio Vivo — Fede &amp; Fitness Italia.
        Tutti i diritti riservati.
      </p>
    </div>
  </footer>
);
